import Link from "next/link";
import { Facebook, Instagram } from "lucide-react";
import { StoreLogo } from "./Header";
import { WhatsAppLink } from "./StoreLinks";
import { STORE } from "../../../lib/site";
export default function Footer() {
  return (
    <footer className="store-footer">
      <div className="store-container footer-grid">
        <div>
          <div className="footer-brand">
            <StoreLogo />
          </div>
          <p>
            Kitchen, household and business supplies.
            <br />
            Your local store in Al Ain.
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <p className="footer-label">Explore</p>
          <Link href="/#offerings">Products We Supply</Link>
          <Link href="/#our-store">Our Store</Link>
          <Link href="/#location">Location</Link>
          <Link href="/about">About</Link>
          <Link href="/products">Browse products →</Link>
        </nav>
        <div>
          <p className="footer-label">Visit &amp; contact</p>
          <p>
            {STORE.streetAddress}
            <br />
            {STORE.addressLocality}, United Arab Emirates
          </p>
          <a href={`tel:${STORE.mobile}`}>{STORE.mobileDisplay}</a>
          <a href={`mailto:${STORE.email}`}>{STORE.email}</a>
        </div>
        <div>
          <p className="footer-label">Let’s stay in touch</p>
          <div className="social-links">
            <a
              href={STORE.facebook}
              aria-label="Shop House on Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={20} />
            </a>
            <a
              href={STORE.instagram}
              aria-label="Shop House on Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={20} />
            </a>
          </div>
          <WhatsAppLink source="footer" />
        </div>
      </div>
      <div className="store-container footer-bottom">
        © {new Date().getFullYear()} Shop House General Trading. All rights
        reserved.
      </div>
    </footer>
  );
}
